/**
 * BriqueChart에서 사용할 Plotly Config의 Default
 *   - Config 속성은 Chart Element의 briqueChartData.configOriginal로 저장된다.
 *   - Config 속성을 개별 화면별로 다르게 설정하려면 newPlot() 호출시 oConfig를 지정하여 호출하면 된다.
 */

// import BriqueChart from './BriqueChart.vue'
// import BriqueChartModebarButtonMixin from './BriqueChartModebarButtonMixin'

export default {
  /**
   * Plotly Config의 Default
   * 호출하는 곳의 설정이 먼저 적용된다.
   */
  defaultConfig: {
    responsive: true,
    scrollZoom: true,
    displaylogo: false,
    displayModeBar: false,
    modeBarButtons: []
  }
}
